import { render } from "./ClientDetailsPage.vue?vue&type=template&id=f43c60fa&scoped=true"
import script from "./ClientDetailsPage.vue?vue&type=script&lang=js"
export * from "./ClientDetailsPage.vue?vue&type=script&lang=js"

import "./ClientDetailsPage.vue?vue&type=style&index=0&id=f43c60fa&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43c60fa"]])

export default __exports__